import http from "./httpService";
import auth from "./authService";

const headers = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

export function getEntryTypes() {
  return http.get(`/v1/gledger/entry-types`);
}

export function getEntrySubTypes(data) {
  return http.post(`/v1/gledger/entry-type-data`, data);
}

export function saveSingle(data) {
  return http.post(`/v1/gledger/save-entry`, data, headers);
}
